import React, { useEffect, useState } from 'react';
import { Container, Form, Button, Table } from 'react-bootstrap';
import apiCall from '../../utils/apiUtils';

const CashoutPage: React.FC = () => {
  const [amount, setAmount] = useState<number>(0);
  const [credit, setCredit] = useState<number>(0);
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    apiCall('/ListCashouts', null, (res: any) => setRows(Array.isArray(res)?res:[]), 'GET');
    apiCall('/SwSS', { ss: '' }, () => {}, 'GET'); // no-op; keep session
    // Load credit
    apiCall('/SVs', { nCategoryId: 0, sp: '', vPostType: 'wish' }, () => {}, 'GET'); // placeholder
    apiCall('/sP', { count: 0 }, () => {}, 'POST'); // ensure table exists
    // Simple credit fetch
    apiCall('/ListPurchases', null, () => {}, 'GET'); // warmup
  }, []);

  const refresh = () => apiCall('/ListCashouts', null, (res: any)=>setRows(Array.isArray(res)?res:[]), 'GET');

  const createRequest = () => {
    apiCall('/CreateCashout', { amount }, (res: any) => { if (res?.success) { setAmount(0); refresh(); } }, 'POST');
  };

  const del = (id: number, status: string) => {
    if (status !== 'unpaid') return;
    apiCall('/DeleteCashout', { id }, (res: any) => { if (res?.success) refresh(); }, 'POST');
  };

  return (
    <Container>
      <h2>Cashout</h2>
      <Form className="d-flex gap-2 mb-3">
        <Form.Control type="number" placeholder="Cashout amount" value={amount} onChange={(e)=>setAmount(parseFloat(e.target.value||'0'))} />
        <Button onClick={createRequest}>Create Request</Button>
      </Form>
      <div className="mb-2">Available Credit: {credit}</div>
      <Table size="sm" bordered>
        <thead><tr><th>ID</th><th>Amount</th><th>Status</th><th>Date</th><th>Actions</th></tr></thead>
        <tbody>
          {rows.map(r=> (
            <tr key={r.id}>
              <td>{r.id}</td>
              <td>{r.amount}</td>
              <td>{r.status}</td>
              <td>{r.dDate}</td>
              <td>{r.status==='unpaid' && <Button size="sm" variant="danger" onClick={()=>del(r.id, r.status)}>Delete</Button>}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default CashoutPage;
